import { createFileRoute } from "@tanstack/react-router";

import { McpConnectPage } from "../components/settings/McpConnectPage";

export const Route = createFileRoute("/settings/mcp-connect")({
  component: McpConnectPage,
});
